import {
  Button,
  Divider,
  EHeadingStyleVariant,
  EModalSize,
  EModalVariants,
  ETextStyleVariant,
  Heading,
  Modal,
  Text,
} from '@outdoorsyco/bonfire';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { IActivity } from '@/components/route/campground/campgroundTypes';
import { useBreakpoint } from '@/hooks/useBreakpoint';

type THighlightsProps = {
  activities?: IActivity[];
};

export const Highlights = ({ activities }: THighlightsProps) => {
  const intl = useIntl();

  if (!activities?.length) return null;

  return (
    <div className="flex flex-col gap-6">
      <Text variant={ETextStyleVariant.LargeBold}>
        {intl.formatMessage({ defaultMessage: 'Highlights', id: 'KGmQjH' })}
      </Text>

      <div className="grid grid-cols-2 gap-4">
        {activities.slice(0, 6).map(({ name }, index) => (
          <Text key={index} variant={ETextStyleVariant.MediumRegular} component="div">
            {name}
          </Text>
        ))}
      </div>

      {activities.length > 6 && (
        <ShowAllHighlights count={activities.length}>
          <div className="grid gap-4">
            {activities.map(({ name }, index) => (
              <div key={index}>
                <Text variant={ETextStyleVariant.MediumRegular} component="div">
                  {name}
                </Text>

                {index < activities.length - 1 && <Divider className="mt-4" />}
              </div>
            ))}
          </div>
        </ShowAllHighlights>
      )}
    </div>
  );
};

type TShowAllHighlightsProps = {
  count: number;
  children: JSX.Element;
};

const ShowAllHighlights = ({ count, children }: TShowAllHighlightsProps) => {
  const intl = useIntl();

  const { isMobile } = useBreakpoint();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <div>
      <Button
        label={intl.formatMessage(
          { defaultMessage: 'Show all {detailCount} amenities', id: 'ACEYOv' },
          { detailCount: count },
        )}
        onClick={() => setModalIsOpen(true)}
      />

      <Modal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        size={EModalSize.Medium}
        variant={isMobile ? EModalVariants.Bottom : undefined}>
        <Modal.Actions />
        <Modal.Header>
          <Heading variant={EHeadingStyleVariant.H6}>
            {intl.formatMessage({ defaultMessage: 'Highlights', id: 'KGmQjH' })}
          </Heading>
        </Modal.Header>
        <Modal.Content>{children}</Modal.Content>
      </Modal>
    </div>
  );
};
